import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid } from 'react-flexbox-grid';

const NotFound = ({ t }) => (
  <Grid>
    <h1>404</h1>
    <p>{t('Požadovanú stránku sa nepodarilo nájsť.')}</p>
  </Grid>
);

NotFound.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(NotFound);



// WEBPACK FOOTER //
// ./src/features/not-found/NotFound.js